import styled from 'styled-components';

import { deviceMaxWidth } from 'utils/constants/style';

export const BackButtonWrap = styled.div`
  position: absolute;
  left: -62px;
  top: 25px;

  @media only screen and (max-width: 995px) {
    display: none;
  }
`;

export const PostDetailsWrap = styled.div`
  width: 100%;
  max-width: 550px;
  position: relative;
  padding-top: 25px;
  padding-bottom: 25px;

  @media only screen and (${deviceMaxWidth.sm}) {
    padding-bottom: 135px;
    box-sizing: border-box;
  }
  // @media (max-width: 767px) {
  //   padding-top: 76px;
  // }
`;

export const ContentWrap = styled.div`
  width: 100%;
  max-width: 550px;
`;
